module.exports = __webpack_public_path__ + "img/39bQ1s4_B8Uit750tn8fxk.c4c0180f.svg";